// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"103":"5a44be0b","453":"8b4b26dc","664":"73a6b553","923":"c7da165c"}[chunkId] + ".chunk.js";
};